// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import { createRoot } from 'react-dom/client';

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    OutlinedInput,
    InputAdornment,
    Tooltip,
    FormControlLabel,
    Checkbox,
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import React from 'react';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList';
import { useToast } from '../../../../components/ToastProvider';
import { get } from 'http';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listItem, setListItem] = useState<any[]>([])
    const [valItem, setValItem] = useState<any>(null)

    const [listJenisProduct, setListJenisProduct] = useState<any[]>([])

    const [openDialogSimulasi, setOpenDialogSimulasi] = useState<boolean>(false)

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogJasa, setOpenDialogJasa] = useState<boolean>(false)
    const [listBagianDetail, setListBagianDetail] = useState<any[]>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)

    const [listProduct, setListProduct] = useState<any[]>([])
    const [listProductJasa, setListProductJasa] = useState<any[]>([])
    const [listBagian, setListBagian] = useState<any[]>([])
    const [listSimulasi, setListSimulasi] = useState<any[]>([])
    const [listJenisBarang, setListJenisBarang] = useState<any[]>([])
    const [listJenisKain, setListJenisKain] = useState<any[]>([])
    const [valJasa, setValJasa] = useState<any>(null)
    const [listBarangJasa, setListBarangJasa] = useState<any[]>([])

    const [valModel, setValModel] = useState<any>(null)
    const [listModel, setListModel] = useState<any[]>([])

    const [quantity, setQuantity] = useState<any>(null)
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<string>('Pilih File')
    const [tabs, setTabs] = useState<string>('1')

    useEffect(() => {
        getListBarang()
        getData();
        getBarangJasa()
    }, [])

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getListProduct(newValue)
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/sales/product/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('nama_product', data.nama_product)
                    setValue('tinggi', data.tinggi)
                    setValue('panjang', data.panjang)
                    setValue('lebar', data.lebar)
                    setValue('keterangan', data.keterangan)
                    setValue('kode', data.kode)
                    setValue('jenis_product', data.jenis_product)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('sdmodel_id', data.sdmodel_id)
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('link', data.link)
                    setValue('is_produksi', data.is_produksi)
                    getListJenis()
                    console.log(data)
                    getDoctag(data.sysdoctag_id)
                    getModel(data.jenis_product)

                    getListBagian()
                    getListProduct(tabs)

                    Swal.close()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListProduct = (tab: any) => {
        const url = apiUrl.apiUrl + '/sales/product/list-product-detail/' + id
        axios
            .get(url, {
                params: { tab: tab },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    setListProduct(data.data)
                    setListProductJasa(data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListBagian = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-bagian'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBagian(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })

    }

    const getListBagianDetail = (bagian: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-bagian-detail/' + bagian
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBagianDetail(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getListBarang = () => {
        const url = apiUrl.apiUrl + '/sales/product/list-barang'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListJenisBarang(response.data.barang)
                    setListJenisKain(response.data.kain)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getBarangJasa = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-barang-jasa/'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarangJasa(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListJenis = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-jenis-model'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListJenisProduct(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getListItem = (jenisBarangId: number) => {
        let isKain = getValues('is_kain') || 0;
        const url = apiUrl.apiUrl + '/sales/model/list-item/' + isKain
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListItem(data)
                    data.forEach((element: any) => {
                        if (element.id === jenisBarangId) {
                            setValItem(element)
                        }
                    });
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const handleChangeAutocompleteItem = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis_barang_id', newValue?.id)
        setValItem(newValue)
    }

    const getModel = (jenisModel: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-combo?jenis_model=' + jenisModel
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListModel(data)
                    data.forEach((element: { id: number; nama: string }) => {
                        if (element.id == getValues('sdmodel_id')) {
                            setValModel(element)
                        }
                    });
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handlePilihBarang = (row: any) => {
        let options = listBarangJasa;
        if (row.is_jasa === 0) {
            if (row.is_kain === 1) {
                options = listJenisKain;
            } else {
                options = listJenisBarang;
            }
        }
        Swal.fire({
            title: 'Pilih Barang',
            html: `<div id="swal-autocomplete"></div>`,
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            didOpen: () => {
                const root = createRoot(document.getElementById('swal-autocomplete')!);
                root.render(
                    <Autocomplete
                        options={options}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                const confirmButton = Swal.getConfirmButton();
                                if (confirmButton) {
                                    confirmButton.addEventListener('click', () => {
                                        const data = {
                                            id: row.id,
                                            mmjenis_barang_id: newValue.id
                                        }

                                        axios.post(apiUrl.apiUrl + '/sales/product/edit-barang', data, {
                                            headers: { Authorization: `Bearer ${token}` }
                                        })
                                            .then(response => {
                                                if (response.data.success) {
                                                    showToast(response.data.message, 'success');
                                                    getListProduct(tabs)
                                                } else {
                                                    showToast(response.data.message, 'error');
                                                }
                                            })
                                    })
                                }
                            }
                        }}
                        renderOption={(props: any, option: any) => (
                            <li {...props} key={option.id}>
                                {option.nama}
                            </li>
                        )}
                        getOptionLabel={(option: any) => option.nama}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label='Pilih Barang'
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                );
            }
        })
    }

    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }
    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
        setValue('image', files)
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdproduct_id: any,
        sdmodel_id: any,
        kode: any,
        jenis_product: any,
        nama_product: any,
        keterangan: any,
        panjang: any,
        lebar: any,
        tinggi: any,
        image: any,
        link: any,

        sdproduct_d_id: any,
        jenis_barang_id: any,
        bagian: string,
        detail_bagian: string,
        kebutuhan_bagian: number,
        panjang_bagian: number,
        lebar_bagian: number,
        tinggi_bagian: number,
        lebihan_panjang_bagian: number,
        lebihan_lebar_bagian: number,
        keterangan_bagian: string,
        is_kain: any,
        qty_bagian: any,
        is_biaya_produksi: any,
        biaya_produksi: any,
        jasa_id: any,
        is_produksi: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/sales/product/edit/' + id
        const formData = new FormData();
        formData.append("kode", data.kode);
        formData.append("jenis_product", data.jenis_product);
        formData.append("nama_product", data.nama_product);
        formData.append("keterangan", data.keterangan);
        formData.append("panjang", data.panjang);
        formData.append("lebar", data.lebar);
        formData.append("tinggi", data.tinggi);
        formData.append("image", file);

        axios.post(url, formData, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    window.location.reload();
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const resetForm = () => {
        setValue('jenis_barang_id', '');
        setValItem(null);
        setListItem([]);
        setValue('bagian', '');
        setValue('detail_bagian', '');
        setValue('kebutuhan_bagian', 1);
        setValue('panjang_bagian', 0);
        setValue('lebar_bagian', 0);
        setValue('tinggi_bagian', 0);
        setValue('lebihan_panjang_bagian', 0);
        setValue('lebihan_lebar_bagian', 0);
        setValue('keterangan_bagian', '');
        setValue('sdproduct_d_id', '');
        setValue('is_biaya_produksi', 0);
        setValue('biaya_produksi', null);
        setValue('jasa_id', null);
        setValJasa(null);
    }

    const handleChangeAutocompleteJasa = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jasa_id', newValue?.id)
        setValue('biaya_produksi', newValue?.harga || 0)
        setValJasa(newValue)
    }

    const simulasiOrder = () => {
        const url = apiUrl.apiUrl + '/sales/product/detail-order-harga'
        axios
            .get(url, {
                params: {
                    sdproduct_id: id,
                    qty_order: quantity
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSimulasi(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const convertComponent = [
        {
            key: "items",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='body2'>
                        {row.value || ""}
                    </Typography>
                    {row.value == null ? (
                        <IconButton
                            color="primary"
                            size="small"
                            onClick={() => { handlePilihBarang(row.data) }}
                            sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                },
                                borderRadius: 1,
                                boxShadow: 1,
                            }}
                        >
                            <Icon icon="mdi:plus" />
                        </IconButton>
                    ) : (
                        <IconButton color="primary" size="small" onClick={() => { handlePilihBarang(row.data) }}>
                            <Icon icon="mdi:pencil" />
                        </IconButton>
                    )}
                </Box>
            ),
        },
        {
            key: "is_kain",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.data.is_kain === 1} readOnly />}
                    />
                );
            },
        },
    ];

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    if (row.is_jasa === 1) {
                        setOpenDialogJasa(true);
                        resetForm();
                        setIsEdit(true);
                        setValue('sdproduct_d_id', row.id);
                        setValue('jenis_barang_id', row.jenis_barang_id);
                        setValue('keterangan_bagian', row.keterangan);
                        setValue('jasa_id', row.jenis_barang_id);
                        setValue('is_biaya_produksi', row.is_biaya_produksi);
                        setValue('biaya_produksi', row.biaya_jasa);
                        setValue('qty_bagian', row.qty);
                        listBarangJasa.forEach(element => {
                            if (element.id == row.jenis_barang_id) {
                                setValJasa(element);
                            }
                        });
                    } else {
                        setOpenDialog(true);
                        resetForm();
                        setIsEdit(true);
                        setValue('sdproduct_d_id', row.id);
                        setValue('jenis_barang_id', row.jenis_barang_id);
                        setValue('bagian', row.jenis_bagian);
                        setValue('is_kain', row.is_kain);
                        getListBagianDetail(row.jenis_bagian);
                        getListItem(row.jenis_barang_id);
                        setValue('qty_bagian', row.qty);
                        setValue('detail_bagian', row.detail_bagian);
                        setValue('kebutuhan_bagian', row.kebutuhan);
                        setValue('panjang_bagian', row.panjang);
                        setValue('lebar_bagian', row.lebar);
                        setValue('lebihan_panjang_bagian', row.lebihan_panjang);
                        setValue('keterangan_bagian', row.keterangan);
                        setValue('is_biaya_produksi', row.is_biaya_produksi);
                        setValue('jasa_id', row.jasa_id);
                        setValue('biaya_produksi', row.biaya_jasa);
                        listBarangJasa.forEach(element => {
                            if (element.id == row.jasa_id) {
                                setValJasa(element);
                            }
                        });
                    }

                }
            },
            {
                title: "Hapus Reclass",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };
    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/sales/product/delete-detail/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getListBarang()
                    getListProduct(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Product {getValues('is_produksi') == '0' ? 'Jasa' : ''}
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                disabled
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1, mt: 1 }}>
                                    Jenis Product
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Jenis Product</InputLabel>
                                    <Controller
                                        name='jenis_product'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Jenis Product'
                                                value={value || ''}
                                                onChange={onChange}
                                                disabled
                                                error={Boolean(errors.jenis_product)}
                                            >
                                                {listJenisProduct.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.jenis_product && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sdmodel_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valModel}
                                                options={listModel}
                                                id='sdmodel_id'
                                                disabled
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Parent Model'
                                                        error={Boolean(errors.sdmodel_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sdmodel_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Product
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_product'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Product'
                                                error={Boolean(errors.nama_product)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_product && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kode Product
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode Product'
                                                error={Boolean(errors.kode)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Panjang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='panjang'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Panjang'
                                                type='number'
                                                error={Boolean(errors.panjang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.panjang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Lebar
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='lebar'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Lebar'
                                                type='number'
                                                error={Boolean(errors.lebar)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.lebar && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tinggi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tinggi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tinggi'
                                                type='number'
                                                error={Boolean(errors.tinggi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tinggi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Upload Gambar
                                </Typography>
                                <input
                                    type='file'
                                    ref={hiddenFileInput}
                                    onChange={handleFile}
                                    style={{ display: 'none' }}
                                    accept='image/png, image/jpg, image/jpeg'
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='image'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errors.image)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Ubah Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errors.image && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={getValues('is_produksi') == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Gambar
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mt: 1 }}
                                    disabled={!getValues('link')}
                                    onClick={() => {
                                        if (!getValues('link')) return;
                                        Swal.fire({
                                            title: 'Gambar Product',
                                            imageUrl: getValues('link'),
                                            imageAlt: 'Gambar Product',
                                            showCloseButton: true,
                                            showConfirmButton: false,
                                            width: 600,
                                            padding: '1em'
                                        });
                                    }}
                                >
                                    Lihat Gambar
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider sx={{ m: 5 }} />
                    </form>
                    <Box sx={{ mt: 4 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Box>
                                <Button variant="contained" color="primary" onClick={() => {
                                    setQuantity(null)
                                    setOpenDialogSimulasi(true)
                                }}>
                                    Buat Simulasi Order
                                </Button>
                            </Box>
                        </Box>
                        <Box sx={{ overflowX: 'auto' }}>
                            <TabContext value={tabs}>
                                <TabList scrollButtons variant='scrollable' onChange={handleChangeTabs} aria-label='customized tabs example'>
                                    <Tab value='1' label='LIST ITEM KAIN' />
                                    <Tab value='2' label='LIST ITEM BUKAN KAIN' />
                                    <Tab value='3' label='LIST JASA' />
                                </TabList>
                                <TabPanel value='1'>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                        <Button variant="contained" color="primary" onClick={() => {
                                            resetForm();
                                            setIsEdit(false);
                                            setOpenDialog(true);
                                            setValue('is_kain', 1);
                                            getListItem(0);
                                        }}>
                                            Tambah Item Kain
                                        </Button>
                                    </Box>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        LIST ITEM KAIN
                                    </Typography>
                                    <Box sx={{ overflowX: 'auto' }}>
                                        <MsiDatagrid key={1} array={listProduct} customRender={convertComponent} hiddenColumns={['jenis_barang_id', 'is_jasa', 'id', 'is_kain', 'qty', 'is_biaya_produksi']} actions={actionData} />
                                    </Box>
                                </TabPanel>
                                <TabPanel value='2'>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                        <Button variant="contained" color="primary" onClick={() => {
                                            resetForm();
                                            setIsEdit(false);
                                            setOpenDialog(true);
                                            setValue('is_kain', 0);
                                            getListItem(0);
                                        }}>
                                            Tambah Item Bukan Kain
                                        </Button>
                                    </Box>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        LIST ITEM BUKAN KAIN
                                    </Typography>
                                    <Box sx={{ overflowX: 'auto' }}>
                                        <MsiDatagrid key={1} array={listProduct} customRender={convertComponent} hiddenColumns={['jenis_barang_id', 'is_jasa', 'id', 'kebutuhan', 'panjang', 'lebar', 'lebihan_panjang', 'lebihan_lebar', 'is_kain', 'is_biaya_produksi']} actions={actionData} />
                                    </Box>
                                </TabPanel>
                                <TabPanel value='3'>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                        <Button variant="contained" color="info" onClick={() => {
                                            resetForm();
                                            setIsEdit(false);
                                            setOpenDialogJasa(true);
                                        }}>
                                            Tambah Jasa
                                        </Button>
                                    </Box>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        LIST JASA
                                    </Typography>
                                    <Box sx={{ overflowX: 'auto' }}>
                                        <MsiDatagrid key={2} array={listProductJasa} customRender={convertComponent} hiddenColumns={['jenis_barang_id', 'is_jasa', 'id', 'jenis_bagian', 'detail_bagian', 'kebutuhan', 'panjang', 'lebar', 'lebihan_panjang', 'lebihan_lebar', 'is_kain']} actions={actionData} />
                                    </Box>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </Box>
                </div>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogSimulasi}
                onClose={() => setOpenDialogSimulasi(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        BUAT SIMULASI ORDER
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                Quantity
                            </Typography>
                            <FormControl fullWidth>
                                <TextField
                                    label='Quantity'
                                    onChange={(e) => setQuantity(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} sx={{ textAlign: 'center', my: 2 }}>
                            <Button variant='contained' onClick={() => simulasiOrder()} disabled={quantity == null || quantity == '' ? true : false}>
                                BUAT SIMULASI ORDER
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                HASIL SIMULASI ORDER
                            </Typography>
                            <MsiDatagrid array={listSimulasi} />
                            {listSimulasi.length > 0 && (
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, color: '#212121' }}>
                                    <Box sx={{ minWidth: 300 }}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                                            Summary
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Jual:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_jual || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Perolehan:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_perolehan || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Min:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_min || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogSimulasi(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data: any) => {
                    const formData = {
                        sdproduct_id: id,
                        jenis_barang_id: getValues('jenis_barang_id'),
                        jenis_bagian: getValues('bagian'),
                        detail_bagian: getValues('detail_bagian'),
                        kebutuhan: getValues('kebutuhan_bagian'),
                        panjang: getValues('panjang_bagian'),
                        lebar: getValues('lebar_bagian'),
                        lebihan_panjang: getValues('lebihan_panjang_bagian'),
                        lebihan_lebar: getValues('lebihan_lebar_bagian'),
                        keterangan: getValues('keterangan_bagian'),
                        is_kain: getValues('is_kain'),
                        qty: getValues('qty_bagian'),
                        is_biaya_produksi: getValues('is_biaya_produksi') ? 1 : 0,
                        biaya_produksi: getValues('biaya_produksi') || 0,
                        jasa_id: getValues('jasa_id') || null,
                    }

                    let url = "";
                    if (isEdit) {
                        url = apiUrl.apiUrl + '/sales/product/update-detail/' + getValues('sdproduct_d_id')
                    } else {
                        url = apiUrl.apiUrl + '/sales/product/add-detail'
                    }
                    axios
                        .post(url, formData, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                getListProduct(tabs)
                                setOpenDialog(false);
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        })

                })
                }>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Item
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <InputLabel>Bagian</InputLabel>
                                    <Controller
                                        name='bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Bagian'
                                                value={value || ''}
                                                onChange={e => {
                                                    onChange(e);
                                                    setValue('bagian', e.target.value);
                                                    getListBagianDetail(e.target.value);
                                                }}
                                                error={Boolean(errors.bagian)}
                                            >
                                                {listBagian.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center" }}>
                                <IconButton
                                    color="primary"
                                    sx={{ backgroundColor: 'primary.main', color: 'white' }}
                                    onClick={async () => {
                                        setOpenDialog(false);
                                        const { value: bagian } = await Swal.fire({
                                            title: 'Masukkan Bagian',
                                            input: 'text',
                                            inputLabel: 'Bagian',
                                            inputPlaceholder: 'Masukkan nama bagian',
                                            showCancelButton: true,
                                            confirmButtonText: 'Simpan',
                                            cancelButtonText: 'Batal'
                                        });
                                        if (bagian) {
                                            axios
                                                .post(apiUrl.apiUrl + '/sales/model/add-bagian', { bagian }, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    Swal.close();
                                                    if (response.data.success) {
                                                        showToast(response.data.message, 'success');
                                                        getListBagian();
                                                        setOpenDialog(true);
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                });
                                        }
                                    }}
                                >
                                    <Icon icon="mdi:plus" />
                                </IconButton>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <InputLabel>Detail Bagian</InputLabel>
                                    <Controller
                                        name='detail_bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Detail Bagian'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.detail_bagian)}
                                            >
                                                {listBagianDetail.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.detail_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center" }}>
                                <IconButton
                                    color="primary"
                                    sx={{ backgroundColor: 'primary.main', color: 'white' }}
                                    onClick={async () => {
                                        if (getValues('bagian') == '' || getValues('bagian') == null) {
                                            alert("Bagian tidak boleh kosong");
                                            return;
                                        }
                                        setOpenDialog(false);
                                        const { value: bagianDetail } = await Swal.fire({
                                            title: 'Masukkan Detail Bagian',
                                            input: 'text',
                                            inputLabel: 'Detail Bagian',
                                            inputPlaceholder: 'Masukkan nama detail bagian',
                                            showCancelButton: true,
                                            confirmButtonText: 'Simpan',
                                            cancelButtonText: 'Batal'
                                        });
                                        if (bagianDetail) {
                                            const bagian = getValues('bagian');
                                            axios
                                                .post(apiUrl.apiUrl + `/sales/model/add-bagian-detail/${bagian}`, { bagian_detail: bagianDetail }, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    Swal.close();
                                                    if (response.data.success) {
                                                        showToast(response.data.message, 'success');
                                                        getListBagianDetail(bagian);
                                                        setOpenDialog(true);
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                    Swal.close();
                                                });

                                        }
                                    }}
                                >
                                    <Icon icon="mdi:plus" />
                                </IconButton>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_barang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valItem}
                                                options={listItem}
                                                id='jenis_barang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteItem}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Item'
                                                        error={Boolean(errors.jenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {
                                watch('is_kain') == 1 ?
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='kebutuhan_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Kebutuhan'
                                                            error={Boolean(errors.kebutuhan_bagian)}
                                                            onChange={onChange}
                                                            type='number'
                                                            value={value}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.kebutuhan_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='panjang_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Panjang'
                                                            error={Boolean(errors.panjang_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.panjang_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebar_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebar'
                                                            error={Boolean(errors.lebar_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebar_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebihan_panjang_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebihan Panjang'
                                                            error={Boolean(errors.lebihan_panjang_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebihan_panjang_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebihan_lebar_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebihan Lebar'
                                                            error={Boolean(errors.lebihan_lebar_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebihan_lebar_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </>
                                    :
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='qty_bagian'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Qty'
                                                        error={Boolean(errors.qty_bagian)}
                                                        onChange={onChange}
                                                        type='number'
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.qty_bagian && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                            }
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='is_biaya_produksi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='Biaya Produksi ?'
                                                sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}
                                                control={
                                                    <Checkbox
                                                        checked={value || false}
                                                        onChange={(e) => {
                                                            onChange(e.target.checked);
                                                            if (e.target.checked) {
                                                                setValue('biaya_produksi', 0);
                                                            } else {
                                                                setValue('biaya_produksi', null);
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {watch('is_biaya_produksi') && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='jasa_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valJasa}
                                                        options={listBarangJasa}
                                                        id='jasa_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteJasa}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Item'
                                                                error={Boolean(errors.jenis_barang_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.jenis_barang_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='biaya_produksi'
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Biaya Produksi'
                                                        error={Boolean(errors.biaya_produksi)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='text'
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                )}
                                            />
                                            {errors.biaya_produksi && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.biaya_produksi.message === 'string' ? errors.biaya_produksi.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_bagian'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan_bagian)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant="contained" color="primary" type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogJasa}
                onClose={() => setOpenDialogJasa(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data: any) => {
                    const formData = {
                        sdproduct_id: id,
                        mmjenis_barang_id: getValues('jasa_id'),
                        qty: getValues('qty_bagian'),
                        keterangan: getValues('keterangan_bagian')
                    }

                    let url = "";
                    if (isEdit) {
                        url = apiUrl.apiUrl + '/sales/product/update-jasa/' + getValues('sdproduct_d_id')
                    } else {
                        url = apiUrl.apiUrl + '/sales/product/add-jasa'
                    }
                    axios
                        .post(url, formData, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                getListProduct(tabs)
                                setOpenDialogJasa(false);
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Jasa
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jasa_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJasa}
                                                options={listBarangJasa}
                                                id='jasa_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJasa}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Item'
                                                        error={Boolean(errors.jenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty_bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Qty'
                                                error={Boolean(errors.qty_bagian)}
                                                onChange={onChange}
                                                type='number'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='biaya_produksi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Biaya Jasa'
                                                error={Boolean(errors.biaya_produksi)}
                                                onChange={onChange}
                                                value={value || ''}
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.biaya_produksi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>
                                            {typeof errors.biaya_produksi.message === 'string' ? errors.biaya_produksi.message : 'Form ini tidak boleh kosong.'}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_bagian'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan_bagian)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant="contained" color="primary" type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogJasa(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
